import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import eventDebugger from 'common/services/-RFC.eventDebugger';
import eventManager from 'common/services/-RFC.eventManager';
import { LicensesRepository, ActivationCodesRepository } from 'common/repositories/index';

angular.module('controllers')
    .controller(
        'BaseModal',
        ($scope, $rootScope, $state, Util, $location) => {

            $scope.close = (newState) => {

                let currentState;

                // OE-7619-cw-add-free-trial-card-when-users-are-dropping-the-purchase-process-in-cw

                const licenses = LicensesRepository.getAll();
                const activationCodes = ActivationCodesRepository.getAll();

                const hasPrimeTrial = licenses.find(license => license.relationships.app.data.id === 'aps10' || license.relationships.app.data.id === 'aps20');
                const hasPrimeLicense = activationCodes.find(activationCode => activationCode.attributes.app === 'aps10' || activationCode.attributes.app === 'aps20');

                if ($rootScope.showPrimeTrialModal && !hasPrimeLicense && !hasPrimeTrial) {

                    const trialModalClosed = sessionStorage.getItem('trialModalClosed');
                    if (($location.path().indexOf('payment-cart') > -1 || $location.path().indexOf('one-click-payment') > -1) &&
                        !trialModalClosed &&
                        $location.path().indexOf('adwp1') === -1) {

                        $state.go($state.current.name, {
                            ltb: 'trial-modal',
                        });

                        return;

                    }

                    if ($location.path().indexOf('trial-modal') > -1 && !trialModalClosed) {

                        sessionStorage.setItem('trialModalClosed', 'true');

                    }

                }
                // OE-7619-cw-add-free-trial-card-when-users-are-dropping-the-purchase-process-in-cw

                if (!newState) {

                    currentState = $state.current.name;
                    newState = currentState.substr(0, currentState.indexOf('.ltb')) || 'root.dashboard.home';

                }
                $state.go(newState);

            };
            // when deploy come from email
            // check if path location contains params 'subscription' and 'deploy'
            // then disable close modal on backdrop click
            const path = $location.path();
            if (path.indexOf('subscription') > -1 && path.indexOf('deploy') > -1) {

                $scope.disableCloseModal = true;

            }

            // Disable close modal on backdrop click for the payment cart
            if (path.indexOf('/ltb/payment-cart') > -1 || path.indexOf('trial-modal') > -1) {

                $scope.disableCloseModalPaymentCart = true;

            }

            // function to save input data for anon modals
            $scope.saveData = () => { };

            $scope.register = (ev) => {

                eventDebugger.addEvent(`#lightbox ${Util.elementToStr(ev.target)}`);

            };

            $scope.changeState = (stateName, stateParams) => {

                $state.go(stateName, stateParams);

            };

            $scope.sendMixpanel = (msg) => {

                Mixpanel.send(msg);

            };

            // initialize modal with default behaviour;
            $scope.cdn = $rootScope.cdn;
            $scope.visibleLog = false;
            $scope.customDebug = CWCONFIG.features.customDebug;
            $scope.hideControls =
                $rootScope.State.hideDashboard ? $rootScope.State.hideDashboard : false;
            $scope.showCloseBtn = true;


            // adjust behaviour on demand based on certain event
            eventManager.subscribe('modal.closeBtn:show', () => {

                $scope.showCloseBtn = true;

            });

            eventManager.subscribe('modal.closeBtn:hide', () => {

                $scope.showCloseBtn = false;

            });

            $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams) => {

                if (fromParams.ltb === 'deploy') {

                    $scope.disableCloseModal = true;

                }

                if (fromParams.ltb === 'payment-cart') {

                    $scope.disableCloseModalPaymentCart = true;

                }

            });

        },

    );



// WEBPACK FOOTER //
// ./scripts/controllers/modals/base.js